
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    ids = [],
    configId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projKpiAudit.setAuditFlowBatch, {
        ids,
        configId,
    }, options);
    if (error) return { error, status };
    return content || { };
};
